import { OperacoesWebAPI } from '../../utils/global';
import api from '../api'

export const municipioEntradaBrasilService = {
    getAllAtivosPorEstado: (estadoID: any) => {
        return api.get(`${OperacoesWebAPI.MunicipioEntradaBrasil}/getallativoporestado`, { params: { estadoID } })
            .then((res) => res)
            .catch(err => err)
    },

    getAllAtivosMS: () => {
        return api.get(`${OperacoesWebAPI.MunicipioEntradaBrasil}/getallativoms`)
            .then((res) => res)
            .catch(err => err)
    },

    post: (municipioEntradaBrasil: any) => {
        return api.post(`${OperacoesWebAPI.MunicipioEntradaBrasil}`, municipioEntradaBrasil)
    },

    put: (municipioEntradaBrasil: any) => {
        return api.put(`${OperacoesWebAPI.MunicipioEntradaBrasil}`, municipioEntradaBrasil)
    },

    delete: (municipioEntradaBrasilID: number) => {
        return api.delete(`${OperacoesWebAPI.MunicipioEntradaBrasil}?id=${municipioEntradaBrasilID}`)
    }
}